import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/guilded': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M443.4 64c0 0.5 0 0.4 0 0.9 0 29.2-2 57.9-5.9 86.1h-336.1s0.4 52 27.1 105.9c27.5 51.8 65.3 85.1 96.5 98.4 32.3-15.1 63.4-41.3 80.5-69.5h-88.6c-22.9-19-41-50.5-45.1-86.9h259.9c-12.8 58.6-40 111.8-65.9 145.8-35.8 46.8-84.3 82.8-140.6 103.5-1.3 0-113.2-33.9-177.3-161.6-21.2-42.3-43.4-119.1-43.4-222.4h438.9z'
      }
    ]
  }
})
